import {Box, CircularProgress, Typography} from "@mui/material";
import {keyframes} from "@emotion/react"

const pulse = keyframes`
    0% {
        transform: scale(1);
        opacity: 0.6;
    }
    50% {
        transform: scale(1.1);
        opacity: 0.8;
    }
    100% {
        transform: scale(1);
        opacity: 0.6;
    }
`

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`

export function LoadingCard() {
  return (
    
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        gap: 4,
        padding: 4,
        borderRadius: 4,
        backgroundColor: "background.paper",
        boxShadow: 3,
        animation: `${fadeIn} 1s ease-out`,
      }}
    >
      <Box
        sx={{
          position: "relative",
          animation: `${pulse} 2s ease-in-out infinite`,
        }}
      >
        <CircularProgress
          size={50}
          thickness={3}
          disableShrink
          sx={{
            color: "primary.main",
          }}
        />
        <CircularProgress
          disableShrink
          size={70}
          thickness={2}
          sx={{
            position: "absolute",
            left: -10,
            top: -10,
            opacity: 0.3,
            color: "primary.main",
            filter: "blur(1px)",
          }}
        />
      </Box>
      <Typography
        variant="h4"
        sx={{
          color: "primary.main",
          fontWeight: "bold",
          letterSpacing: "0.1em",
          animation: `${fadeIn} 1s ease-out 0.3s both`,
        }}
      >
        読み込み中
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          letterSpacing: "0.05em",
          maxWidth: "400px",
          lineHeight: 1.8,
          animation: `${fadeIn} 1s ease-out 0.6s both`,
        }}
      >
        しばらくお待ちください...
      </Typography>
    </Box>
  )
}